var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSquareDashed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64 392V352H0V392C0 440.531 39.469 480 88 480H128V416H88C74.781 416 64 405.234 64 392ZM64 192H0V320H64V192ZM160 480H288V416H160V480ZM0 120V160H64V120C64 106.766 74.781 96 88 96H128V32H88C39.469 32 0 71.469 0 120ZM160 96H288V32H160V96ZM360 32H320V96H360C373.219 96 384 106.766 384 120V160H448V120C448 71.469 408.531 32 360 32ZM384 320H448V192H384V320ZM384 392C384 405.234 373.219 416 360 416H320V480H360C408.531 480 448 440.531 448 392V352H384V392Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareDashed);
export default __webpack_public_path__ + "static/media/square-dashed.6289da3200ea8246e20202168c0136b3.svg";
export { ForwardRef as ReactComponent };